import {
	HomeIcon,
	Cog6ToothIcon,
	BanknotesIcon,
	LinkIcon,
	UsersIcon,
	UserGroupIcon,
	CalendarDaysIcon,
	ClipboardDocumentCheckIcon,
	DocumentTextIcon,
	CurrencyDollarIcon,
} from '@heroicons/react/24/outline';
import { USER_ROLE } from '../../types/auth';
import { NavigationConfig } from './types';

export const providerNav: NavigationConfig = [
	{
		items: [
			{
				icon: HomeIcon,
				label: 'Dashboard',
				path: '/providers/dashboard',
				roles: [USER_ROLE.SALON_OWNER],
			},
		],
	},
	{
		title: 'Business',
		items: [
			{
				icon: BanknotesIcon,
				label: 'Payment Setup',
				path: '/providers/payment-setup',
				roles: [USER_ROLE.SALON_OWNER],
			},
			{
				icon: LinkIcon,
				label: 'Integrations',
				path: '/providers/integrations',
				roles: [USER_ROLE.SALON_OWNER],
			},
			{
				icon: CalendarDaysIcon,
				label: 'Appointments',
				path: '/providers/appointments',
				roles: [USER_ROLE.SALON_OWNER],
			},
			{
				icon: ClipboardDocumentCheckIcon,
				label: 'TCR',
				path: '/providers/tcr',
				roles: [USER_ROLE.SALON_OWNER],
				children: [
					{ label: 'Approvals', path: '/providers/tcr-approvals' },
					{ label: 'Payments', path: '/providers/tcr-payments' },
				],
			},
			{
				icon: DocumentTextIcon,
				label: 'Invoices',
				path: '/providers/invoices',
				roles: [USER_ROLE.SALON_OWNER],
			},
			{
				icon: CurrencyDollarIcon,
				label: 'Revenue',
				path: '/providers/revenue',
				roles: [USER_ROLE.SALON_OWNER],
			},
		],
	},
	{
		title: 'Team',
		items: [
			{
				icon: UsersIcon,
				label: 'Staff Management',
				path: '/providers/staff-management',
				roles: [USER_ROLE.SALON_OWNER],
			},
		],
	},
	{
		title: 'Customers',
		items: [
			{
				icon: UserGroupIcon,
				label: 'Customer List',
				path: '/providers/customers',
				roles: [USER_ROLE.SALON_OWNER],
			},
		],
	},
	{
		title: 'Configuration',
		items: [
			{
				icon: Cog6ToothIcon,
				label: 'Settings',
				path: '/providers/settings',
				roles: [USER_ROLE.SALON_OWNER],
			},
		],
	},
];
